import { motion } from "framer-motion";
import type { ReactNode } from "react";

interface AnimatedButtonProps {
  children: ReactNode;
  variant?: "default" | "primary" | "danger";
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
}

export function AnimatedButton({
  children,
  variant = "default",
  className = "",
  disabled,
  type = "button",
  onClick,
}: AnimatedButtonProps): ReactNode {
  return (
    <motion.button
      className={`animated-button animated-button-${variant} ${className}`}
      whileHover={disabled ? undefined : { y: -1, boxShadow: "var(--shadow-lg)" }}
      whileTap={disabled ? undefined : { scale: 0.97 }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      {children}
    </motion.button>
  );
}
